import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    token: "", //登录需要token
    limit: 8, // 每页条数
    login: false // 登陆状态
  },
  getters: {
    // breadListState(state) {
    //   if (!state.breadList.length) {
    //     state.breadList = JSON.parse(sessionStorage.getItem('breadList')) || [];
    //   }
    //   return state.breadList
    // },
  },
  mutations: {
    // BREADLISTSTORAGE(state, list) {
    //   state.breadList = list;
    //   sessionStorage.setItem('breadList', JSON.stringify(state.breadList))
    // },
    SETLOGIN(state, payload) {
      state.login = payload;
    },
    SETTOKEN(state, payload) {
      state.token = payload;
    }
  },
  actions: {
    // setLogin(context, payload) {
    //   context.commit("SETLOGIN", payload)
    // },
    setToken(c, payload) {
      c.commit("SETTOKEN", payload);
    },
    setLogin(c, payload) {
      c.commit("SETLOGIN", payload);
    }
  },
  modules: {}
});



// WEBPACK FOOTER //
// ./src/store/index.js